import type { TicketStatus } from '@/types/ticket'
import { nextStatuses, statusLabels } from '@/lib/status'

export function StatusSelect({ value, onChange, disabled }: { value: TicketStatus; onChange: (s: TicketStatus) => void; disabled?: boolean }) {
  const options: TicketStatus[] = [value, ...nextStatuses(value)]
  return (
    <select disabled={disabled} value={value} onChange={e => onChange(e.target.value as TicketStatus)} className="border rounded px-2 py-1 text-sm">
      {options.map(s => <option key={s} value={s}>{statusLabels[s]}</option>)}
    </select>
  )
}
